import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageClick = (page) => {
    if (page !== currentPage) {
      onPageChange(page); // Call the function passed as a prop
    }
  };

  // Validate totalPages to avoid invalid array length
  if (totalPages <= 0) {
    return <div>No pages to display</div>; // Or return null
  }

  return (
    <div className="flex justify-center items-center flex-wrap">
      {/* Render dots for each page */}
      {[...Array(totalPages)].map((_, index) => {
        const page = index + 1; // Page numbers start from 1
        const isActive = page === currentPage;

        return (
          <React.Fragment key={page}>
            <div
              className={`border ${
                isActive ? "border-primary" : "border-[#C4C4C4]"
              } rounded-full w-8 h-8 p-1 cursor-pointer`}
              onClick={() => handlePageClick(page)} // Handle page click
            >
              <div
                className={`rounded-full ${
                  isActive ? "bg-primary" : "bg-[#C4C4C4]"
                } w-full h-full`}
              ></div>
            </div>
            {index < totalPages - 1 && (
              <div className="w-8 h-[2px] bg-[#C4C4C4]"></div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Pagination;
